import React from "react";
import axios from "axios";
import api from "axios.js";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Paper from "@material-ui/core/Paper";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import {} from "assets/jss/material-dashboard-react.js";
import { connect } from "react-redux";
import Actions from "redux/actions";
import AssociationList from "components/AssociationList";
import Form from "components/MuiJsonForm";
import { withRouter } from "react-router";
import MaterialTable from "components/MaterialTable.js";
import PubSub from "pubsub-js";
import {
  parametresListColumns,
  equipementsColumns,
  usersColumns,
} from "utils/columns";
import { userSchema } from "utils/schemas";

class Parametres extends React.Component {
  constructor(props) {
    super(props);
    this.dispatch = this.props.dispatch;
    this.cancelSources = new Set();
    this.logoPreviewObjectUrl = null;
    this.quittancePreviewObjectUrl = null;
    this._isMounted = false;

    this.state = {
      activeTab: 0,
      previewSeed: Date.now(),

      designLoading: false,
      appBrandingLoading: false,
      logoUploading: false,
      homeLogoUploading: false,
      faviconUploading: false,
      logoMeta: null,
      logoPreviewUrl: null,
      appBranding: null,

      emailLoading: false,
      emailSavingGlobal: false,
      emailSavingTemplate: false,
      emailSavingLogo: false,
      emailSettings: null,
      selectedEmailTemplateId: "",
      emailEditorMode: "visual",
      emailEditorSubject: "",
      emailEditorHtml: "",
      emailVisualDraft: {},
      emailGlobalDraft: {
        brandName: "",
        brandSiteUrl: "",
        logoUrl: "",
        includeLogo: true,
      },

      quittanceLoading: false,
      quittanceSaving: false,
      quittancePreviewLoading: false,
      quittanceSettingsError: "",
      quittancePreviewUrl: null,
      quittanceDraft: {
        accentColor: "#3665A4",
        city: "Sevres",
        issuanceLineTemplate: "{city}, le {dateLong}",
        titleTemplate: "QUITTANCE N°{numero}",
        monthLineTemplate: "LOYER DU MOIS DE {dateMoisUpper}",
        periodLineTemplate: "SOIT DU {dateDebutMois} AU {dateFinMoisUpper}",
        footerText:
          "MDVB Conseil SARL au capital de 500 EUR - No 821099447 RCS de Nanterre - 9 rue des Pommerets 92310 Sevres",
        includeLogo: true,
      },

      documentTemplatesLoading: false,
      documentTemplatesSaving: false,
      documentTemplateUploading: false,
      documentTemplateDownloading: "",
      documentTemplatesError: "",
      documentTemplates: [],
      selectedDocumentTemplateId: "",
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.cancelAllRequests("Parametres unmounted");
    this.revokeQuitanceLogoPreview();
    this.revokeQuittancePdfPreview();
  }

  updateState = (updater, cb) => {
    if (!this._isMounted) return;
    this.setState(updater, cb);
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
  };

  trackPromise = (promise, source) => {
    if (promise && typeof promise.finally === "function") {
      promise.finally(() => this.releaseCancelSource(source));
    } else {
      this.releaseCancelSource(source);
    }
    return promise;
  };

  isSuperadmin = () => this.props.currentUser?.role === "superadmin";

  getSettingsTabs = () => {
    const tabs = [];
    if (this.isSuperadmin()) {
      tabs.push({ key: "design", label: "Design de l'app", render: this.renderDesignTab });
      tabs.push({ key: "emails", label: "Reglage des emails", render: this.renderEmailsTab });
      tabs.push({ key: "quittance", label: "Quittance PDF", render: this.renderQuittanceTab });
      tabs.push({ key: "templates", label: "Templates documents", render: this.renderTemplatesTab });
    }
    tabs.push({ key: "system", label: "Systeme", render: this.renderSystemTab });
    return tabs;
  };

  getUsersRoleLookup = () =>
    this.isSuperadmin()
      ? {
          superadmin: "Super Admin",
          admin: "Admin",
          user: "Ajout / Edition",
          user_delete: "Ajout / Edition / Suppression",
        }
      : {
          user: "Ajout / Edition",
          user_delete: "Ajout / Edition / Suppression",
        };

  getUsersColumns = () =>
    usersColumns.map((column) =>
      column.field === "role"
        ? { ...column, lookup: this.getUsersRoleLookup() }
        : column
    );

  getErrorMessage = (error, fallback) => {
    if (!error) return fallback;
    const responseMessage = error?.response?.data?.error;
    if (responseMessage) return responseMessage;
    if (error?.message) return error.message;
    return fallback;
  };

  withCache = (url) => {
    if (!url) return null;
    const joiner = url.includes("?") ? "&" : "?";
    return `${url}${joiner}v=${this.state.previewSeed}`;
  };

  bumpPreviewSeed = () => this.updateState({ previewSeed: Date.now() });

  revokeQuitanceLogoPreview = () => {
    if (this.logoPreviewObjectUrl) {
      URL.revokeObjectURL(this.logoPreviewObjectUrl);
      this.logoPreviewObjectUrl = null;
    }
  };

  revokeQuittancePdfPreview = () => {
    if (this.quittancePreviewObjectUrl) {
      URL.revokeObjectURL(this.quittancePreviewObjectUrl);
      this.quittancePreviewObjectUrl = null;
    }
  };

  refreshQuitanceLogoPreview = () => {
    const source = this.createCancelSource();
    return this.trackPromise(
      api
        .get("/design/quittance-logo/preview", {
          responseType: "blob",
          cancelToken: source.token,
        })
        .then((response) => {
          if (!response?.data) return;
          this.revokeQuitanceLogoPreview();
          this.logoPreviewObjectUrl = URL.createObjectURL(response.data);
          this.updateState({ logoPreviewUrl: this.logoPreviewObjectUrl });
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({ logoPreviewUrl: null });
        }),
      source
    );
  };

  loadQuitanceLogoSettings = () => {
    this.updateState({ designLoading: true });
    const source = this.createCancelSource();
    return this.trackPromise(
      api
        .get("/design/quittance-logo", { cancelToken: source.token })
        .then((response) => {
          this.updateState({ logoMeta: response?.data || null });
          return this.refreshQuitanceLogoPreview();
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({
            logoMeta: {
              error: this.getErrorMessage(error, "Impossible de charger le logo quittance."),
            },
          });
        })
        .finally(() => this.updateState({ designLoading: false })),
      source
    );
  };

  loadAppBranding = () => {
    this.updateState({ appBrandingLoading: true });
    const source = this.createCancelSource();
    return this.trackPromise(
      api
        .get("/design/app-branding", { cancelToken: source.token })
        .then((response) => this.updateState({ appBranding: response?.data || null }))
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({
            appBranding: {
              error: this.getErrorMessage(error, "Impossible de charger le branding."),
            },
          });
        })
        .finally(() => this.updateState({ appBrandingLoading: false })),
      source
    );
  };

  uploadAsset = ({ endpoint, fieldName, stateKey, successText }) => (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append(fieldName, file);
    this.updateState({ [stateKey]: true });

    const source = this.createCancelSource();
    this.trackPromise(
      api
        .post(endpoint, formData, {
          cancelToken: source.token,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          PubSub.notif({ txt: successText, color: "success", icon: "image" });
          this.bumpPreviewSeed();
          return Promise.all([
            this.loadQuitanceLogoSettings(),
            this.loadAppBranding(),
            this.loadEmailSettings(),
          ]);
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          PubSub.notif({
            txt: this.getErrorMessage(error, "Upload impossible."),
            color: "danger",
            icon: "error",
          });
        })
        .finally(() => {
          if (event?.target) event.target.value = "";
          this.updateState({ [stateKey]: false });
        }),
      source
    );
  };

  handleQuitanceLogoUpload = this.uploadAsset({
    endpoint: "/design/quittance-logo",
    fieldName: "logo",
    stateKey: "logoUploading",
    successText: "Logo quittance mis a jour.",
  });

  handleHomeLogoUpload = this.uploadAsset({
    endpoint: "/design/app-branding/home-logo",
    fieldName: "logo",
    stateKey: "homeLogoUploading",
    successText: "Logo page d'accueil mis a jour.",
  });

  handleFaviconUpload = this.uploadAsset({
    endpoint: "/design/app-branding/favicon",
    fieldName: "favicon",
    stateKey: "faviconUploading",
    successText: "Favicon mise a jour.",
  });

  handleEmailLogoUpload = this.uploadAsset({
    endpoint: "/design/email-settings/logo",
    fieldName: "logo",
    stateKey: "emailSavingLogo",
    successText: "Logo email mis a jour.",
  });

  loadEmailSettings = () => {
    this.updateState({ emailLoading: true });
    const source = this.createCancelSource();
    return this.trackPromise(
      api
        .get("/design/email-settings", { cancelToken: source.token })
        .then((response) => {
          const payload = response?.data || {};
          const templates = Array.isArray(payload.templates) ? payload.templates : [];
          const selectedId =
            templates.find((t) => t.id === this.state.selectedEmailTemplateId)?.id ||
            templates[0]?.id ||
            "";
          const active = templates.find((t) => t.id === selectedId);
          this.updateState({
            emailSettings: payload,
            selectedEmailTemplateId: selectedId,
            emailEditorSubject: active?.subject || "",
            emailEditorHtml: active?.html || "",
            emailVisualDraft: { ...(active?.visualValues || {}) },
            emailGlobalDraft: {
              brandName: payload?.global?.brandName || "",
              brandSiteUrl: payload?.global?.brandSiteUrl || "",
              logoUrl: payload?.global?.logoUrl || "",
              includeLogo:
                typeof payload?.global?.includeLogo === "boolean"
                  ? payload.global.includeLogo
                  : true,
            },
          });
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({
            emailSettings: {
              error: this.getErrorMessage(error, "Impossible de charger les reglages emails."),
              templates: [],
              global: {
                brandName: "",
                brandSiteUrl: "",
                logoUrl: "",
                includeLogo: true,
              },
            },
            emailVisualDraft: {},
            emailGlobalDraft: {
              brandName: "",
              brandSiteUrl: "",
              logoUrl: "",
              includeLogo: true,
            },
          });
        })
        .finally(() => this.updateState({ emailLoading: false })),
      source
    );
  };

  selectEmailTemplate = (templateId) => {
    const templates = this.state.emailSettings?.templates || [];
    const found = templates.find((t) => t.id === templateId);
    if (!found) return;
    this.updateState({
      selectedEmailTemplateId: found.id,
      emailEditorSubject: found.subject || "",
      emailEditorHtml: found.html || "",
      emailVisualDraft: { ...(found.visualValues || {}) },
      emailEditorMode:
        (found.visualFields || []).length > 0 ? this.state.emailEditorMode : "html",
    });
  };

  escapeHtml = (value) =>
    String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  formatVisualValueForPreview = (value) =>
    this.escapeHtml(value).replace(/\r?\n/g, "<br />");

  applyTokens = (template, values = {}) => {
    let output = String(template || "");
    Object.entries(values).forEach(([key, value]) => {
      output = output.replace(
        new RegExp(`\\{${key}\\}`, "g"),
        value == null ? "" : String(value)
      );
    });
    return output;
  };

  removeEmailLogoMarkup = (html) =>
    String(html || "")
      .replace(
        /<a\b[^>]*>\s*<img\b[^>]*class=["'][^"']*\blogo\b[^"']*["'][^>]*>\s*<\/a>/gi,
        ""
      )
      .replace(/<img\b[^>]*class=["'][^"']*\blogo\b[^"']*["'][^>]*>/gi, "")
      .replace(/<img\b[^>]*src=["']\s*["'][^>]*>/gi, "");

  getActiveEmailTemplate = (templates = this.state.emailSettings?.templates || []) =>
    templates.find((template) => template.id === this.state.selectedEmailTemplateId) || null;

  buildEmailPreviewHtml = (template, globalDraft, visualDraft) => {
    if (!template?.html) return "";
    const includeLogo = Boolean(globalDraft?.includeLogo);
    const visualTokens = {};
    (template.visualFields || []).forEach((field) => {
      visualTokens[field.id] = this.formatVisualValueForPreview(
        visualDraft?.[field.id] ?? field.defaultValue ?? ""
      );
    });
    const withDesign = this.applyTokens(template.html, {
      logo: includeLogo
        ? globalDraft?.logoUrl || this.state.emailSettings?.global?.logoUrl || ""
        : "",
      brandSiteUrl:
        globalDraft?.brandSiteUrl || this.state.emailSettings?.global?.brandSiteUrl || "#",
      brandName:
        globalDraft?.brandName || this.state.emailSettings?.global?.brandName || "Patrimoine",
      urlYes: "#",
      urlNo: "#",
      ...visualTokens,
    });

    const finalHtml = this.applyTokens(withDesign, {
      mois: "janvier",
      annee: "2026",
      moisAnnee: "janvier 2026",
      adresseappartement: "15 rue de la Paix, Paris",
      situationdubien: "(T2)",
      locataireprenom: "Jean",
      locatairenom: "Dupont",
      totalTTC: "950",
    });
    return includeLogo ? finalHtml : this.removeEmailLogoMarkup(finalHtml);
  };

  saveEmailGlobal = () => {
    this.updateState({ emailSavingGlobal: true });
    const source = this.createCancelSource();
    this.trackPromise(
      api
        .put(
          "/design/email-settings/global",
          {
            brandName: this.state.emailGlobalDraft.brandName,
            brandSiteUrl: this.state.emailGlobalDraft.brandSiteUrl,
            logoUrl: this.state.emailGlobalDraft.logoUrl,
            includeLogo: this.state.emailGlobalDraft.includeLogo,
          },
          { cancelToken: source.token }
        )
        .then(() => {
          PubSub.notif({ txt: "Reglages emails enregistres.", color: "success", icon: "save" });
          return this.loadEmailSettings();
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          PubSub.notif({
            txt: this.getErrorMessage(error, "Impossible d'enregistrer les reglages emails."),
            color: "danger",
            icon: "error",
          });
        })
        .finally(() => this.updateState({ emailSavingGlobal: false })),
      source
    );
  };

  saveEmailTemplate = () => {
    const templateId = this.state.selectedEmailTemplateId;
    if (!templateId) return;
    this.updateState({ emailSavingTemplate: true });
    const payload = {
      subject: this.state.emailEditorSubject,
      visual: this.state.emailVisualDraft,
    };
    if (this.state.emailEditorMode === "html") {
      payload.html = this.state.emailEditorHtml;
    }
    const source = this.createCancelSource();
    this.trackPromise(
      api
        .put(
          `/design/email-settings/template/${templateId}`,
          payload,
          { cancelToken: source.token }
        )
        .then((response) => {
          const updated = response?.data?.template;
          if (updated) {
            const templates = (this.state.emailSettings?.templates || []).map((t) =>
              t.id === updated.id ? updated : t
            );
            this.updateState((prev) => ({
              emailSettings: { ...(prev.emailSettings || {}), templates },
            }));
          }
          PubSub.notif({ txt: "Template email enregistre.", color: "success", icon: "save" });
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          PubSub.notif({
            txt: this.getErrorMessage(error, "Impossible d'enregistrer le template."),
            color: "danger",
            icon: "error",
          });
        })
        .finally(() => this.updateState({ emailSavingTemplate: false })),
      source
    );
  };

  loadQuittanceSettings = () => {
    this.updateState({ quittanceLoading: true, quittanceSettingsError: "" });
    const source = this.createCancelSource();
    return this.trackPromise(
      api
        .get("/design/quittance-settings", { cancelToken: source.token })
        .then((response) => {
          const payload = response?.data || {};
          this.updateState({
            quittanceDraft: {
              accentColor: payload.accentColor || "#3665A4",
              city: payload.city || "Sevres",
              issuanceLineTemplate:
                payload.issuanceLineTemplate || "{city}, le {dateLong}",
              titleTemplate: payload.titleTemplate || "QUITTANCE N°{numero}",
              monthLineTemplate:
                payload.monthLineTemplate || "LOYER DU MOIS DE {dateMoisUpper}",
              periodLineTemplate:
                payload.periodLineTemplate ||
                "SOIT DU {dateDebutMois} AU {dateFinMoisUpper}",
              footerText:
                payload.footerText ||
                "MDVB Conseil SARL au capital de 500 EUR - No 821099447 RCS de Nanterre - 9 rue des Pommerets 92310 Sevres",
              includeLogo:
                typeof payload.includeLogo === "boolean" ? payload.includeLogo : true,
            },
          });
          return this.refreshQuittancePreview(payload);
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({
            quittanceSettingsError: this.getErrorMessage(
              error,
              "Impossible de charger les reglages de quittance."
            ),
          });
        })
        .finally(() => this.updateState({ quittanceLoading: false })),
      source
    );
  };

  refreshQuittancePreview = (draft = this.state.quittanceDraft) => {
    const source = this.createCancelSource();
    this.updateState({ quittancePreviewLoading: true });
    return this.trackPromise(
      api
        .post("/design/quittance-settings/preview", draft, {
          responseType: "blob",
          cancelToken: source.token,
        })
        .then((response) => {
          if (!response?.data) return;
          this.revokeQuittancePdfPreview();
          this.quittancePreviewObjectUrl = URL.createObjectURL(response.data);
          this.updateState({ quittancePreviewUrl: this.quittancePreviewObjectUrl });
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({
            quittanceSettingsError: this.getErrorMessage(
              error,
              "Impossible de generer l'apercu de quittance."
            ),
            quittancePreviewUrl: null,
          });
        })
        .finally(() => this.updateState({ quittancePreviewLoading: false })),
      source
    );
  };

  saveQuittanceSettings = () => {
    this.updateState({ quittanceSaving: true, quittanceSettingsError: "" });
    const source = this.createCancelSource();
    return this.trackPromise(
      api
        .put("/design/quittance-settings", this.state.quittanceDraft, {
          cancelToken: source.token,
        })
        .then(() => {
          PubSub.notif({
            txt: "Reglages de quittance enregistres.",
            color: "success",
            icon: "save",
          });
          return this.refreshQuittancePreview();
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({
            quittanceSettingsError: this.getErrorMessage(
              error,
              "Impossible d'enregistrer les reglages de quittance."
            ),
          });
        })
        .finally(() => this.updateState({ quittanceSaving: false })),
      source
    );
  };

  getSelectedDocumentTemplate = (
    templates = this.state.documentTemplates || []
  ) =>
    templates.find((template) => template.id === this.state.selectedDocumentTemplateId) ||
    null;

  loadDocumentTemplates = () => {
    this.updateState({ documentTemplatesLoading: true, documentTemplatesError: "" });
    const source = this.createCancelSource();
    return this.trackPromise(
      api
        .get("/design/document-templates", { cancelToken: source.token })
        .then((response) => {
          const templates = Array.isArray(response?.data?.templates)
            ? response.data.templates
            : [];
          const selectedId =
            templates.find((t) => t.id === this.state.selectedDocumentTemplateId)?.id ||
            templates[0]?.id ||
            "";
          this.updateState({
            documentTemplates: templates,
            selectedDocumentTemplateId: selectedId,
          });
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          this.updateState({
            documentTemplatesError: this.getErrorMessage(
              error,
              "Impossible de charger les templates documents."
            ),
            documentTemplates: [],
            selectedDocumentTemplateId: "",
          });
        })
        .finally(() => this.updateState({ documentTemplatesLoading: false })),
      source
    );
  };

  selectDocumentTemplate = (templateId) => {
    this.updateState({ selectedDocumentTemplateId: templateId });
  };

  updateDocumentTemplateActiveSource = (activeSource) => {
    const templateId = this.state.selectedDocumentTemplateId;
    if (!templateId) return;
    this.updateState({ documentTemplatesSaving: true });
    const source = this.createCancelSource();
    this.trackPromise(
      api
        .put(
          `/design/document-templates/${templateId}/active-source`,
          { activeSource },
          { cancelToken: source.token }
        )
        .then(() => {
          PubSub.notif({
            txt: "Template actif mis a jour.",
            color: "success",
            icon: "save",
          });
          return this.loadDocumentTemplates();
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          PubSub.notif({
            txt: this.getErrorMessage(error, "Impossible de changer le template actif."),
            color: "danger",
            icon: "error",
          });
        })
        .finally(() => this.updateState({ documentTemplatesSaving: false })),
      source
    );
  };

  uploadDocumentTemplate = (event) => {
    const templateId = this.state.selectedDocumentTemplateId;
    const file = event?.target?.files?.[0];
    if (!templateId || !file) return;
    const formData = new FormData();
    formData.append("template", file);
    this.updateState({ documentTemplateUploading: true });
    const source = this.createCancelSource();
    this.trackPromise(
      api
        .post(`/design/document-templates/${templateId}/upload`, formData, {
          cancelToken: source.token,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          PubSub.notif({
            txt: "Template personnalise upload et active.",
            color: "success",
            icon: "description",
          });
          return this.loadDocumentTemplates();
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          PubSub.notif({
            txt: this.getErrorMessage(error, "Upload du template impossible."),
            color: "danger",
            icon: "error",
          });
        })
        .finally(() => {
          if (event?.target) event.target.value = "";
          this.updateState({ documentTemplateUploading: false });
        }),
      source
    );
  };

  getFileNameFromDisposition = (headerValue, fallback) => {
    if (!headerValue) return fallback;
    const utf8Match = headerValue.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      try {
        return decodeURIComponent(utf8Match[1]);
      } catch (_) {}
    }
    const asciiMatch = headerValue.match(/filename="?([^";]+)"?/i);
    if (asciiMatch?.[1]) return asciiMatch[1];
    return fallback;
  };

  downloadDocumentTemplate = (variant = "active") => {
    const template = this.getSelectedDocumentTemplate();
    if (!template) return;
    const templateId = template.id;
    const isExample = variant === "example";
    const endpoint = isExample
      ? `/design/document-templates/${templateId}/example`
      : `/design/document-templates/${templateId}/download`;
    const source = this.createCancelSource();
    this.updateState({ documentTemplateDownloading: `${templateId}:${variant}` });
    this.trackPromise(
      api
        .get(endpoint, {
          params: isExample ? undefined : { variant },
          responseType: "blob",
          cancelToken: source.token,
        })
        .then((response) => {
          const fallbackName = isExample
            ? `EXEMPLE-${template.fileName || templateId}`
            : template.fileName || `${templateId}.${template.format || "docx"}`;
          const fileName = this.getFileNameFromDisposition(
            response?.headers?.["content-disposition"],
            fallbackName
          );
          const blobUrl = URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
          URL.revokeObjectURL(blobUrl);
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;
          PubSub.notif({
            txt: this.getErrorMessage(error, "Telechargement du template impossible."),
            color: "danger",
            icon: "error",
          });
        })
        .finally(() => this.updateState({ documentTemplateDownloading: "" })),
      source
    );
  };

  loadData = () => {
    const variablesSource = this.createCancelSource();
    this.trackPromise(
      this.dispatch(Actions.getVariables({ cancelToken: variablesSource.token })),
      variablesSource
    );
    const equipementsSource = this.createCancelSource();
    this.trackPromise(
      this.dispatch(Actions.getEquipements({ cancelToken: equipementsSource.token })),
      equipementsSource
    );
    const usersSource = this.createCancelSource();
    this.trackPromise(
      this.dispatch(Actions.getUsers({ cancelToken: usersSource.token })),
      usersSource
    );
    if (this.isSuperadmin()) {
      this.loadQuitanceLogoSettings();
      this.loadAppBranding();
      this.loadEmailSettings();
      this.loadQuittanceSettings();
      this.loadDocumentTemplates();
    }
  };

  renderDesignTab = () => {
    const c = this.props.classes;
    const {
      designLoading,
      appBrandingLoading,
      logoUploading,
      homeLogoUploading,
      faviconUploading,
      logoMeta,
      logoPreviewUrl,
      appBranding,
    } = this.state;

    return (
      <div className={c.panel}>
        <h3 className={c.title}>Design de l'app</h3>
        <p className={c.subtitle}>Personnalisez les logos, la page d'accueil et la favicon.</p>
        <div className={c.grid}>
          <div className={c.card}>
            <strong>Logo quittance PDF</strong>
            <div className={c.preview}>{logoPreviewUrl ? <img src={logoPreviewUrl} alt='logo quittance' className={c.img} /> : <span className={c.placeholder}>Apercu indisponible</span>}</div>
            <p className={c.meta}>Source: {logoMeta?.effectiveSource === "custom" ? "Personnalisee" : "Par defaut"}</p>
            {logoMeta?.error ? <p className={c.error}>{logoMeta.error}</p> : null}
            <input id='upload-q-logo' className={c.hidden} type='file' accept='image/png,image/jpeg' onChange={this.handleQuitanceLogoUpload} />
            <label htmlFor='upload-q-logo'><Button component='span' color='primary' variant='contained' disabled={logoUploading || designLoading}>{logoUploading ? "Mise a jour..." : "Remplacer"}</Button></label>
          </div>

          <div className={c.card}>
            <strong>Logo page d'accueil</strong>
            <div className={c.preview}>{appBranding?.homeLogoUrl ? <img src={this.withCache(appBranding.homeLogoUrl)} alt='logo accueil' className={c.img} /> : <span className={c.placeholder}>Aucun logo configure</span>}</div>
            {appBranding?.error ? <p className={c.error}>{appBranding.error}</p> : null}
            <input id='upload-home-logo' className={c.hidden} type='file' accept='image/png,image/jpeg,image/svg+xml,image/webp' onChange={this.handleHomeLogoUpload} />
            <label htmlFor='upload-home-logo'><Button component='span' color='primary' variant='contained' disabled={homeLogoUploading || appBrandingLoading}>{homeLogoUploading ? "Mise a jour..." : "Remplacer"}</Button></label>
          </div>

          <div className={c.card}>
            <strong>Favicon</strong>
            <div className={c.preview}>{appBranding?.faviconUrl ? <img src={this.withCache(appBranding.faviconUrl)} alt='favicon' className={c.favicon} /> : <span className={c.placeholder}>Aucune favicon configuree</span>}</div>
            <input id='upload-favicon' className={c.hidden} type='file' accept='.ico,image/x-icon,image/vnd.microsoft.icon,image/png,image/svg+xml' onChange={this.handleFaviconUpload} />
            <label htmlFor='upload-favicon'><Button component='span' color='primary' variant='contained' disabled={faviconUploading || appBrandingLoading}>{faviconUploading ? "Mise a jour..." : "Remplacer"}</Button></label>
          </div>
        </div>
        <div className={c.actions}><Button variant='outlined' onClick={() => Promise.all([this.loadQuitanceLogoSettings(), this.loadAppBranding()])} disabled={designLoading || appBrandingLoading}>{designLoading || appBrandingLoading ? <CircularProgress size={18} /> : "Rafraichir"}</Button></div>
      </div>
    );
  };

  renderEmailsTab = () => {
    const c = this.props.classes;
    const {
      emailLoading,
      emailSavingGlobal,
      emailSavingTemplate,
      emailSavingLogo,
      emailSettings,
      selectedEmailTemplateId,
      emailEditorMode,
      emailEditorSubject,
      emailEditorHtml,
      emailVisualDraft,
      emailGlobalDraft,
    } = this.state;

    const templates = emailSettings?.templates || [];
    const activeTemplate = this.getActiveEmailTemplate(templates);
    const visualFields = activeTemplate?.visualFields || [];
    const previewHtml = this.buildEmailPreviewHtml(
      activeTemplate,
      emailGlobalDraft,
      emailVisualDraft
    );

    return (
      <div className={c.panel}>
        <h3 className={c.title}>Reglage des emails</h3>
        <p className={c.subtitle}>
          Modifiez vos emails en mode visuel, ou basculez en HTML avance pour un controle total.
        </p>
        {emailSettings?.error ? <p className={c.error}>{emailSettings.error}</p> : null}

        <div className={c.emailGlobal}>
          <TextField label='Nom de marque' variant='outlined' size='small' value={emailGlobalDraft.brandName} onChange={(e) => this.updateState({ emailGlobalDraft: { ...emailGlobalDraft, brandName: e.target.value } })} />
          <TextField label='Lien principal' variant='outlined' size='small' value={emailGlobalDraft.brandSiteUrl} onChange={(e) => this.updateState({ emailGlobalDraft: { ...emailGlobalDraft, brandSiteUrl: e.target.value } })} />
          <TextField label='URL logo email' variant='outlined' size='small' value={emailGlobalDraft.logoUrl} onChange={(e) => this.updateState({ emailGlobalDraft: { ...emailGlobalDraft, logoUrl: e.target.value } })} />
          <FormControlLabel
            control={
              <Checkbox
                color='primary'
                checked={Boolean(emailGlobalDraft.includeLogo)}
                onChange={(e) =>
                  this.updateState({
                    emailGlobalDraft: {
                      ...emailGlobalDraft,
                      includeLogo: e.target.checked,
                    },
                  })
                }
              />
            }
            label='Afficher le logo dans les emails'
          />
          <div className={c.emailActions}>
            <Button color='primary' variant='contained' onClick={this.saveEmailGlobal} disabled={emailSavingGlobal || emailLoading}>{emailSavingGlobal ? "Enregistrement..." : "Enregistrer global"}</Button>
            <input id='upload-email-logo' className={c.hidden} type='file' accept='image/png,image/jpeg,image/svg+xml,image/webp' onChange={this.handleEmailLogoUpload} />
            <label htmlFor='upload-email-logo'><Button component='span' variant='outlined' disabled={emailSavingLogo || emailLoading}>{emailSavingLogo ? "Mise a jour..." : "Uploader logo email"}</Button></label>
          </div>
        </div>

        <div className={c.emailLayout}>
          <div className={c.templateList}>
            {templates.map((t) => (
              <button key={t.id} type='button' className={`${c.templateBtn} ${t.id === selectedEmailTemplateId ? c.templateBtnActive : ""}`} onClick={() => this.selectEmailTemplate(t.id)}>
                <span>{t.name}</span>
                <small>{t.source === "custom" ? "Personnalise" : "Par defaut"}</small>
              </button>
            ))}
          </div>
          <div className={c.editor}>
            <TextField
              label='Objet'
              variant='outlined'
              fullWidth
              value={emailEditorSubject}
              onChange={(e) => this.updateState({ emailEditorSubject: e.target.value })}
              helperText='Placeholders: {moisAnnee}, {adresseappartement}, {situationdubien}'
            />
            <div className={c.modeSwitch}>
              <Button
                color='primary'
                variant={emailEditorMode === "visual" ? "contained" : "outlined"}
                onClick={() => this.updateState({ emailEditorMode: "visual" })}
                disabled={!visualFields.length}
              >
                Visuel
              </Button>
              <Button
                color='primary'
                variant={emailEditorMode === "html" ? "contained" : "outlined"}
                onClick={() => this.updateState({ emailEditorMode: "html" })}
              >
                HTML avance
              </Button>
            </div>

            {emailEditorMode === "visual" ? (
              visualFields.length ? (
                <div className={c.visualGrid}>
                  <div className={c.visualForm}>
                    {visualFields.map((field) => (
                      <TextField
                        key={field.id}
                        label={field.label}
                        variant='outlined'
                        fullWidth
                        multiline={Boolean(field.multiline)}
                        rows={field.multiline ? 4 : 1}
                        value={emailVisualDraft[field.id] ?? ""}
                        onChange={(e) =>
                          this.updateState({
                            emailVisualDraft: {
                              ...emailVisualDraft,
                              [field.id]: e.target.value,
                            },
                          })
                        }
                      />
                    ))}
                  </div>
                  <div className={c.previewCard}>
                    <div className={c.previewTitle}>Apercu live</div>
                    {previewHtml ? (
                      <iframe
                        title='Apercu email'
                        className={c.emailPreviewFrame}
                        srcDoc={previewHtml}
                      />
                    ) : (
                      <div className={c.previewEmpty}>Apercu indisponible.</div>
                    )}
                  </div>
                </div>
              ) : (
                <p className={c.placeholder}>
                  Ce template ne supporte pas le mode visuel. Utilisez HTML avance.
                </p>
              )
            ) : (
              <TextField
                label='Contenu HTML'
                variant='outlined'
                fullWidth
                multiline
                rows={18}
                value={emailEditorHtml}
                onChange={(e) => this.updateState({ emailEditorHtml: e.target.value })}
              />
            )}
            <div className={c.emailActions}>
              <Button color='primary' variant='contained' onClick={this.saveEmailTemplate} disabled={emailSavingTemplate || emailLoading || !selectedEmailTemplateId}>{emailSavingTemplate ? "Enregistrement..." : "Enregistrer template"}</Button>
              <Button variant='outlined' onClick={this.loadEmailSettings} disabled={emailLoading}>{emailLoading ? <CircularProgress size={18} /> : "Rafraichir"}</Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderQuittanceTab = () => {
    const c = this.props.classes;
    const {
      quittanceLoading,
      quittanceSaving,
      quittancePreviewLoading,
      quittanceSettingsError,
      quittancePreviewUrl,
      quittanceDraft,
    } = this.state;
    return (
      <div className={c.panel}>
        <h3 className={c.title}>Reglage de la quittance PDF</h3>
        <p className={c.subtitle}>
          Personnalisez les textes et le style du PDF, puis previsualisez le rendu.
        </p>
        {quittanceSettingsError ? <p className={c.error}>{quittanceSettingsError}</p> : null}

        <div className={c.visualGrid}>
          <div className={c.visualForm}>
            <TextField
              label='Couleur principale (hex)'
              variant='outlined'
              fullWidth
              value={quittanceDraft.accentColor}
              onChange={(e) =>
                this.updateState({
                  quittanceDraft: {
                    ...quittanceDraft,
                    accentColor: e.target.value,
                  },
                })
              }
              helperText='Exemple: #3665A4'
            />
            <TextField
              label='Ville'
              variant='outlined'
              fullWidth
              value={quittanceDraft.city}
              onChange={(e) =>
                this.updateState({
                  quittanceDraft: { ...quittanceDraft, city: e.target.value },
                })
              }
            />
            <TextField
              label="Ligne d'emission"
              variant='outlined'
              fullWidth
              value={quittanceDraft.issuanceLineTemplate}
              onChange={(e) =>
                this.updateState({
                  quittanceDraft: {
                    ...quittanceDraft,
                    issuanceLineTemplate: e.target.value,
                  },
                })
              }
              helperText='Variables: {city}, {dateLong}'
            />
            <TextField
              label='Titre'
              variant='outlined'
              fullWidth
              value={quittanceDraft.titleTemplate}
              onChange={(e) =>
                this.updateState({
                  quittanceDraft: {
                    ...quittanceDraft,
                    titleTemplate: e.target.value,
                  },
                })
              }
              helperText='Variable: {numero}'
            />
            <TextField
              label='Ligne mois'
              variant='outlined'
              fullWidth
              value={quittanceDraft.monthLineTemplate}
              onChange={(e) =>
                this.updateState({
                  quittanceDraft: {
                    ...quittanceDraft,
                    monthLineTemplate: e.target.value,
                  },
                })
              }
              helperText='Variable: {dateMoisUpper}'
            />
            <TextField
              label='Ligne periode'
              variant='outlined'
              fullWidth
              value={quittanceDraft.periodLineTemplate}
              onChange={(e) =>
                this.updateState({
                  quittanceDraft: {
                    ...quittanceDraft,
                    periodLineTemplate: e.target.value,
                  },
                })
              }
              helperText='Variables: {dateDebutMois}, {dateFinMoisUpper}'
            />
            <TextField
              label='Texte pied de page'
              variant='outlined'
              fullWidth
              multiline
              rows={4}
              value={quittanceDraft.footerText}
              onChange={(e) =>
                this.updateState({
                  quittanceDraft: {
                    ...quittanceDraft,
                    footerText: e.target.value,
                  },
                })
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  color='primary'
                  checked={Boolean(quittanceDraft.includeLogo)}
                  onChange={(e) =>
                    this.updateState({
                      quittanceDraft: {
                        ...quittanceDraft,
                        includeLogo: e.target.checked,
                      },
                    })
                  }
                />
              }
              label='Afficher le logo sur la quittance PDF'
            />
            <div className={c.emailActions}>
              <Button
                color='primary'
                variant='contained'
                onClick={this.saveQuittanceSettings}
                disabled={quittanceSaving || quittanceLoading}
              >
                {quittanceSaving ? "Enregistrement..." : "Enregistrer"}
              </Button>
              <Button
                variant='outlined'
                onClick={() => this.refreshQuittancePreview()}
                disabled={quittancePreviewLoading || quittanceLoading}
              >
                {quittancePreviewLoading ? "Generation..." : "Rafraichir apercu"}
              </Button>
              <Button
                variant='outlined'
                onClick={this.loadQuittanceSettings}
                disabled={quittanceLoading}
              >
                {quittanceLoading ? <CircularProgress size={18} /> : "Recharger reglages"}
              </Button>
            </div>
          </div>

          <div className={c.previewCard}>
            <div className={c.previewTitle}>Apercu PDF</div>
            {quittancePreviewUrl ? (
              <iframe
                title='Apercu quittance'
                className={c.quittancePreviewFrame}
                src={quittancePreviewUrl}
              />
            ) : (
              <div className={c.previewEmpty}>Apercu indisponible.</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderTemplatesTab = () => {
    const c = this.props.classes;
    const {
      documentTemplatesLoading,
      documentTemplatesSaving,
      documentTemplateUploading,
      documentTemplateDownloading,
      documentTemplatesError,
      documentTemplates,
    } = this.state;
    const selectedTemplate = this.getSelectedDocumentTemplate(documentTemplates);
    const uploadInputId = selectedTemplate
      ? `upload-doc-template-${selectedTemplate.id}`
      : "upload-doc-template";
    const fileAccept =
      selectedTemplate?.format === "xlsx"
        ? ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/octet-stream"
        : ".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/octet-stream";

    const isDownloading = (variant) =>
      Boolean(selectedTemplate) &&
      documentTemplateDownloading === `${selectedTemplate.id}:${variant}`;

    return (
      <div className={c.panel}>
        <h3 className={c.title}>Templates documents</h3>
        <p className={c.subtitle}>
          Choisissez le template actif, telechargez le fichier en cours, importez un nouveau
          template et consultez les variables disponibles.
        </p>
        {documentTemplatesError ? <p className={c.error}>{documentTemplatesError}</p> : null}

        <div className={c.docTemplateLayout}>
          <div className={c.docTemplateList}>
            {documentTemplates.map((template) => (
              <button
                key={template.id}
                type='button'
                className={`${c.docTemplateBtn} ${
                  template.id === selectedTemplate?.id ? c.docTemplateBtnActive : ""
                }`}
                onClick={() => this.selectDocumentTemplate(template.id)}
              >
                <span className={c.docTemplateBtnTitle}>{template.name}</span>
                <small className={c.docTemplateBtnMeta}>
                  {template.format?.toUpperCase()} | Actif:{" "}
                  {template.effectiveActiveSource === "custom"
                    ? "Personnalise"
                    : "Par defaut"}
                </small>
              </button>
            ))}
            {!documentTemplates.length && !documentTemplatesLoading ? (
              <div className={c.placeholder}>Aucun template trouve.</div>
            ) : null}
          </div>

          <div className={c.docTemplateDetail}>
            {selectedTemplate ? (
              <>
                <div className={c.docTemplateHead}>
                  <div>
                    <h4 className={c.docTemplateTitle}>{selectedTemplate.name}</h4>
                    <p className={c.docTemplateDescription}>{selectedTemplate.description}</p>
                  </div>
                  <div className={c.docTemplateBadges}>
                    <span className={c.badge}>{selectedTemplate.format?.toUpperCase()}</span>
                    <span className={c.badgeMuted}>
                      {selectedTemplate.effectiveActiveSource === "custom"
                        ? "Actif: Personnalise"
                        : "Actif: Par defaut"}
                    </span>
                  </div>
                </div>

                <div className={c.docTemplateActions}>
                  <Button
                    color='primary'
                    variant='contained'
                    onClick={() => this.downloadDocumentTemplate("active")}
                    disabled={isDownloading("active") || documentTemplatesLoading}
                  >
                    {isDownloading("active") ? "Telechargement..." : "Telecharger actif"}
                  </Button>
                  <Button
                    variant='outlined'
                    onClick={() => this.downloadDocumentTemplate("example")}
                    disabled={isDownloading("example") || documentTemplatesLoading}
                  >
                    {isDownloading("example")
                      ? "Telechargement..."
                      : "Telecharger exemple"}
                  </Button>
                  <Button
                    variant='outlined'
                    onClick={() => this.downloadDocumentTemplate("default")}
                    disabled={isDownloading("default") || documentTemplatesLoading}
                  >
                    {isDownloading("default")
                      ? "Telechargement..."
                      : "Telecharger par defaut"}
                  </Button>
                </div>

                <div className={c.docTemplateSection}>
                  <strong>Template actif</strong>
                  <div className={c.emailActions}>
                    <Button
                      color='primary'
                      variant={
                        selectedTemplate.configuredActiveSource === "default"
                          ? "contained"
                          : "outlined"
                      }
                      disabled={documentTemplatesSaving || documentTemplatesLoading}
                      onClick={() => this.updateDocumentTemplateActiveSource("default")}
                    >
                      Utiliser par defaut
                    </Button>
                    <Button
                      color='primary'
                      variant={
                        selectedTemplate.configuredActiveSource === "custom"
                          ? "contained"
                          : "outlined"
                      }
                      disabled={
                        documentTemplatesSaving ||
                        documentTemplatesLoading ||
                        !selectedTemplate.hasCustomTemplate
                      }
                      onClick={() => this.updateDocumentTemplateActiveSource("custom")}
                    >
                      Utiliser personnalise
                    </Button>
                  </div>
                  {!selectedTemplate.hasCustomTemplate ? (
                    <p className={c.docTemplateHint}>
                      Aucun template personnalise charge pour ce document.
                    </p>
                  ) : null}
                </div>

                <div className={c.docTemplateSection}>
                  <strong>Remplacer le template</strong>
                  <p className={c.docTemplateHint}>
                    Uploadez un nouveau fichier {selectedTemplate.format?.toUpperCase()}. Il sera
                    active automatiquement.
                  </p>
                  <input
                    id={uploadInputId}
                    className={c.hidden}
                    type='file'
                    accept={fileAccept}
                    onChange={this.uploadDocumentTemplate}
                  />
                  <label htmlFor={uploadInputId}>
                    <Button
                      component='span'
                      color='primary'
                      variant='contained'
                      disabled={documentTemplateUploading || documentTemplatesLoading}
                    >
                      {documentTemplateUploading ? "Upload..." : "Uploader un template"}
                    </Button>
                  </label>
                </div>

                <div className={c.docTemplateSection}>
                  <strong>Variables utilisables</strong>
                  <div className={c.variablesList}>
                    {(selectedTemplate.variables || []).map((variable, index) => (
                      <div key={`${selectedTemplate.id}-var-${index}`} className={c.variableRow}>
                        <code className={c.variableKey}>{variable.key}</code>
                        <span className={c.variableDesc}>{variable.description}</span>
                      </div>
                    ))}
                    {!selectedTemplate.variables?.length ? (
                      <span className={c.placeholder}>
                        Aucune variable documentee pour ce template.
                      </span>
                    ) : null}
                  </div>
                </div>
              </>
            ) : (
              <div className={c.placeholder}>Selectionnez un template pour commencer.</div>
            )}
          </div>
        </div>

        <div className={c.actions}>
          <Button
            variant='outlined'
            onClick={this.loadDocumentTemplates}
            disabled={documentTemplatesLoading}
          >
            {documentTemplatesLoading ? <CircularProgress size={18} /> : "Rafraichir"}
          </Button>
        </div>
      </div>
    );
  };

  renderSystemTab = () => {
    const { variables, equipements, users, currentUser } = this.props;
    const isSuperadmin = this.isSuperadmin();
    const managedUsers =
      (users || []).filter(
        (user) =>
          user.id !== currentUser?.id &&
          (isSuperadmin || !["admin", "superadmin"].includes(user.role))
      ) || [];
    return (
      <div>
        <MaterialTable
          title='Variables'
          isLoading={!variables}
          columns={parametresListColumns}
          data={Object.entries(variables || {}).map(([k, v]) => v)}
          onRowClick={(_) => null}
          options={{ filtering: false, paging: false, pageSize: 20, actionsColumnIndex: -1 }}
          editable={{ onRowUpdate: (newData) => this.dispatch(Actions.setVariable(newData.id, newData)) }}
        />
        <MaterialTable
          title='Equipements'
          isLoading={!equipements}
          style={{ marginTop: 20, marginBottom: 20 }}
          columns={equipementsColumns}
          data={equipements}
          onRowClick={(_) => null}
          options={{ filtering: false, paging: false, pageSize: 20, actionsColumnIndex: -1 }}
          actions={[
            {
              icon: "delete",
              tooltip: "Supprimer l'equipement",
              onClick: (_, rowData) =>
                PubSub.confirm({
                  title: "Supprimer l'equipement ?",
                  subtitle: "Cette action est irreversible.",
                  onAgree: (_) => this.dispatch(Actions.deleteEquipement(rowData.id)),
                }),
            },
          ]}
          editable={{ onRowUpdate: (newData) => this.dispatch(Actions.setEquipement(newData.id, newData)) }}
        />
        <AssociationList
          title='Utilisateurs'
          data={managedUsers}
          columns={this.getUsersColumns()}
          actions={[
            {
              icon: "settings_backup_restore",
              tooltip: "Reinitialiser le mot de passe",
              onClick: (_, rowData) =>
                PubSub.confirm({
                  title: "Reinitialiser le mot de passe",
                  subtitle: "Cette action est irreversible.",
                  onAgree: (_) =>
                    this.dispatch(Actions.resetPassword(rowData.id)).then((_) => {
                      PubSub.notif({
                        txt: "Le mot de passe a bien ete reinitialise.",
                        color: "success",
                        icon: "settings_backup_restore",
                      });
                    }),
                }),
            },
          ]}
          onTopRightButton={(close) => (
            <Form
              style={{ width: 200 }}
              {...userSchema({}, true, false, currentUser?.role)}
              onSubmit={({ formData: { data } }) => {
                this.dispatch(Actions.addUser(data)).then((_) => {
                  this.loadData();
                  close();
                });
              }}
              onError={console.log}
            />
          )}
          editable={{ onRowUpdate: (newData) => this.dispatch(Actions.setUser(newData.id, newData)) }}
          topRightButtonTxt='Ajouter un utilisateur'
          noDataTxt='Aucun utilisateur.'
          removeTxt="Supprimer l'utilisateur"
          onRemove={(userId) => this.dispatch(Actions.deleteUser(userId))}
        />
      </div>
    );
  };

  render() {
    const c = this.props.classes;
    const tabs = this.getSettingsTabs();
    const activeTab = Math.min(this.state.activeTab, tabs.length - 1);
    const activeTabConfig = tabs[activeTab];
    return (
      <div className={c.container}>
        <Paper className={c.tabsWrap} elevation={0}>
          <Tabs
            value={activeTab}
            onChange={(_, tab) => this.updateState({ activeTab: tab })}
            indicatorColor='primary'
            textColor='primary'
          >
            {tabs.map((tab) => (
              <Tab key={tab.key} label={tab.label} />
            ))}
          </Tabs>
        </Paper>

        {activeTabConfig ? activeTabConfig.render() : null}
      </div>
    );
  }
}

const styles = () => ({
  container: {},
  tabsWrap: {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    marginBottom: 16,
    background: "#fff",
  },
  panel: {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    background: "#fff",
    padding: 20,
    marginBottom: 16,
  },
  title: { margin: 0, color: "#0f172a", fontSize: 20 },
  subtitle: { marginTop: 8, color: "#475569" },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: 12,
  },
  card: {
    border: "1px solid #e2e8f0",
    borderRadius: 10,
    padding: 12,
    background: "#f8fafc",
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  preview: {
    minHeight: 110,
    border: "1px dashed #cbd5e1",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#fff",
    padding: 8,
  },
  img: { maxWidth: "100%", maxHeight: 90, objectFit: "contain" },
  favicon: { width: 48, height: 48, objectFit: "contain" },
  placeholder: { color: "#64748b", fontSize: 13 },
  meta: { margin: 0, fontSize: 12, color: "#334155" },
  error: { color: "#b91c1c", fontSize: 13, margin: 0 },
  actions: { marginTop: 12, display: "flex", justifyContent: "flex-end" },
  hidden: { display: "none" },
  emailGlobal: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
    gap: 10,
    marginBottom: 14,
  },
  emailLayout: {
    display: "grid",
    gridTemplateColumns: "240px 1fr",
    gap: 12,
  },
  templateList: { display: "flex", flexDirection: "column", gap: 8 },
  templateBtn: {
    border: "1px solid #cbd5e1",
    borderRadius: 10,
    background: "#fff",
    padding: "10px 12px",
    textAlign: "left",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  templateBtnActive: {
    borderColor: "#2563eb",
    background: "#eff6ff",
  },
  editor: { display: "flex", flexDirection: "column", gap: 10 },
  modeSwitch: { display: "flex", gap: 10, flexWrap: "wrap" },
  visualGrid: {
    display: "grid",
    gridTemplateColumns: "minmax(300px, 1fr) minmax(320px, 1fr)",
    gap: 12,
    alignItems: "start",
  },
  visualForm: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  previewCard: {
    border: "1px solid #cbd5e1",
    borderRadius: 10,
    overflow: "hidden",
    background: "#fff",
  },
  previewTitle: {
    padding: "8px 12px",
    borderBottom: "1px solid #e2e8f0",
    fontWeight: 600,
    color: "#0f172a",
    background: "#f8fafc",
  },
  emailPreviewFrame: {
    width: "100%",
    height: 520,
    border: "none",
    background: "#fff",
  },
  quittancePreviewFrame: {
    width: "100%",
    height: 760,
    border: "none",
    background: "#fff",
  },
  previewEmpty: {
    padding: 16,
    color: "#64748b",
  },
  emailActions: { display: "flex", gap: 10, flexWrap: "wrap" },
  docTemplateLayout: {
    display: "grid",
    gridTemplateColumns: "280px 1fr",
    gap: 12,
  },
  docTemplateList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  docTemplateBtn: {
    border: "1px solid #cbd5e1",
    borderRadius: 10,
    background: "#fff",
    padding: "10px 12px",
    textAlign: "left",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  docTemplateBtnActive: {
    borderColor: "#2563eb",
    background: "#eff6ff",
  },
  docTemplateBtnTitle: {
    fontWeight: 600,
    color: "#0f172a",
  },
  docTemplateBtnMeta: {
    color: "#475569",
  },
  docTemplateDetail: {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    background: "#f8fafc",
    padding: 14,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  docTemplateHead: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "flex-start",
  },
  docTemplateTitle: {
    margin: 0,
    color: "#0f172a",
  },
  docTemplateDescription: {
    marginTop: 6,
    marginBottom: 0,
    color: "#475569",
  },
  docTemplateBadges: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
  },
  badge: {
    borderRadius: 999,
    padding: "4px 10px",
    fontSize: 12,
    fontWeight: 600,
    color: "#1d4ed8",
    background: "#dbeafe",
  },
  badgeMuted: {
    borderRadius: 999,
    padding: "4px 10px",
    fontSize: 12,
    color: "#334155",
    background: "#e2e8f0",
  },
  docTemplateActions: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
  docTemplateSection: {
    border: "1px solid #dbe3ee",
    borderRadius: 10,
    background: "#fff",
    padding: 12,
    display: "flex",
    flexDirection: "column",
    gap: 10,
  },
  docTemplateHint: {
    margin: 0,
    fontSize: 13,
    color: "#475569",
  },
  variablesList: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
  variableRow: {
    display: "grid",
    gridTemplateColumns: "minmax(180px, 240px) 1fr",
    gap: 12,
    alignItems: "start",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    background: "#f8fafc",
    padding: "8px 10px",
  },
  variableKey: {
    color: "#0f172a",
    background: "#e2e8f0",
    borderRadius: 6,
    padding: "2px 8px",
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  variableDesc: {
    color: "#334155",
    fontSize: 13,
  },
  "@media (max-width: 960px)": {
    emailLayout: {
      gridTemplateColumns: "1fr",
    },
    visualGrid: {
      gridTemplateColumns: "1fr",
    },
    docTemplateLayout: {
      gridTemplateColumns: "1fr",
    },
    variableRow: {
      gridTemplateColumns: "1fr",
    },
  },
});

const mapStateToProps = (state) => ({
  variables: state.reducer.variables,
  equipements: state.reducer.equipements,
  users: state.reducer.users,
  currentUser: state.reducer.currentUser,
});

export default withRouter(withStyles(styles)(connect(mapStateToProps)(Parametres)));
